module.exports = __webpack_public_path__ + "img/project-details-3.60cf1d6e.jpg";